import { FeatureFlagSet } from 'hooks/feature-flags/featureFlagSet'
import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'

type AccountingPageAccessibilityFlags = Pick<
  FeatureFlagSet,
  | 'isAccountingPageVisible'
  | 'isCustomErpMappingsEnabled'
  | 'enableGrandCanyonErpSync'
  | 'isPublicSector'
>

export const getIsAccountingPageAccessible = ({
  isAccountingPageVisible,
  isCustomErpMappingsEnabled,
  enableGrandCanyonErpSync,
  isPublicSector,
}: AccountingPageAccessibilityFlags): boolean =>
  (isAccountingPageVisible || isCustomErpMappingsEnabled) &&
  enableGrandCanyonErpSync &&
  !isPublicSector

export const useIsAccountingPageAccessible = (): boolean => {
  const flags = useFeatureFlags()

  return getIsAccountingPageAccessible(flags)
}
